import { useState, useEffect } from 'react';

import { Button } from '../Button';

const initial = localStorage.getItem('theme');
if (initial === 'dark') {
  document.documentElement.setAttribute('data-theme', 'dark');
}

export const ThemeToggle = ({ className }: { className?: string }) => {
  const [isDarkMode, setIsDarkMode] = useState(initial === 'dark');

  useEffect(() => {
    // При монтировании компонента проверяем сохраненную тему
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  }, []);

  const toggleTheme = () => {
    if (isDarkMode) {
      // Переключение на светлую тему
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', 'light');
    } else {
      // Переключение на темную тему
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    }
    setIsDarkMode(!isDarkMode);
  };

  return (
    <Button className={className} color="secondary" onClick={toggleTheme}>
      {isDarkMode ? '☀️' : '🌙'}
    </Button>
  );
};
